<template>
  <div>
    <b-container v-if="!!petOwnerOrderMessage">
      <b-row>
        <b-col cols="12" sm="12" md="10" offset-md="1" lg="8" offset-lg="2" xl="8" offset-xl="2">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <b-alert variant="warning" :show="!!petOwnerOrderMessage" v-html="petOwnerOrderMessage" />
        </b-col>
      </b-row>
    </b-container>
    <base-container>
      <h1 class="mt-4 mb-3 text-center text-lg font-weight-bold">{{ $t('views.confirmation.thanks') }}</h1>
      <h2 class="font-weight-bold text-dark text-center mb-1">{{ $t('views.confirmation.orderNumber', [order.id]) }}</h2>
      <h3 v-if="order && order.hasShippableItems" class="text-dark text-center">{{ $t('views.confirmation.gettingReady') }}</h3>

      <b-button :href="orderHistoryPageLink" class="mt-4" variant="primary" block>
        {{ $t('views.confirmation.viewOrder') }}
      </b-button>
      <b-button :href="accountLink" class="mt-2 mb-5" variant="outline-primary" block>
        {{ $t('views.confirmation.toAccount') }}
      </b-button>

      <h3 class="font-weight-bold text-dark mb-1">{{ $t('views.confirmation.summary') }}</h3>
      <hr class="mt-0" />
      <totals />
    </base-container>

    <div v-if="membershipCtaPostPurchaseUrl" class="container p-0">
      <div id="membership-cta" class="py-0 pl-4 pr-0 col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 offset-md-2 offset-lg-3 offset-xl-3 mt-0 mb-0 mt-sm-4 mb-sm-4">

        <b-row class="m-0 pt-4">
          <b-col cols="12" sm="6" class="p-0 pr-4 mb-4">
            <img :src="require('@/assets/membership_cta.png')" alt="gifts for your pet" class="w-100 h-100 object-fit-cover rounded-8" />
          </b-col>

          <b-col cols="12" sm="6" class="p-0 pr-4 mb-4">
            <h2 class="font-weight-bold">{{ $t('views.confirmation.membershipCTA.title') }}</h2>
            <p class="h6 mb-4">{{ $t('views.confirmation.membershipCTA.body') }}</p>
            <b-button :href="membershipCtaPostPurchaseUrl" variant="outline-primary" block class="font-weight-bold mt-6 px-4 py-2.5 rounded-8 lh-1">
              {{ $t('views.confirmation.membershipCTA.button') }}
            </b-button>
          </b-col>

        </b-row>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import totals from '@/components/basket/Totals.vue';
import BaseContainer from '@/components/BaseContainer';

export default {
  components: {
    totals,
    BaseContainer,
  },
  computed: {
    ...mapState({
      order: (state) => state.order.order,
      locale: (state) => state.locale,
      petOwnerOrderMessage: (state) => state.order?.order?.city?.petOwnerOrderMessage,
    }),
    accountLink() {
      return this.$store.getters.generateFullUrl('/account/full/account-app');
    },
    orderHistoryPageLink() {
      return `${this.accountLink}/settings/order-history`;
    },
    membershipCtaPostPurchaseUrl() {
      return this.order?.petOwner?.membershipCtaPostPurchaseUrl;
    },
  },
  created() {
    if (!this.order?.id) {
      this.$router.push({ name: 'Basket' });
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
#donation-success-icon {
  color: $dp-green;
  background-color: $dp-white;
  border-radius: 100%;
}

#membership-cta {
  border-top: 1px solid $neutral-200;
  background-color: $dp-white;

  .rounded-8 {
    border-radius: 8px;
  }

  .lh-1 {
    line-height: 1rem;
  }

  .object-fit-cover {
    object-fit: cover;
  }

  h2 {
    color: $sky-800;
    font-size: 1.125rem;
  }

  p {
    color: $neutral-700;
  }

  a {
    color: $blue-800;
    border: 1px solid $blue-800;
    width: fit-content;
    height: fit-content;
    inline-size: fit-content;
    block-size: fit-content;
    &:hover {
      background-color: $cyan-400;
      color: $blue-800;
    }

  }
}

@media screen and (min-width: 576px) {
  #membership-cta {
    border: 1px solid $neutral-200;
    border-radius: 8px;
    box-shadow: 1px 2px 3px #d6d1d1;
    overflow: hidden;
    img {
      min-height: 160px;
    }
    position: relative;
  }
}
</style>
